import { assocPath, equals, path as findPath } from "ramda";
import React from "react";

import { Path, Value } from "lib/build/schema";

import { usePrev } from "src/common/hooks/usePrev";

export function useComputedValue(
	fn: (...args: any[]) => any,
	{
		value: root,
		setValue: setRoot
	}: { value: Value; setValue(fn: (value: Value) => Value): unknown },
	{ sources, target }: { sources: Path[]; target: Path }
): void {
	const prevData = usePrev(root);
	React.useEffect(() => {
		if (
			sources.some(
				path => !equals(findPath(path, root), findPath(path, prevData))
			)
		) {
			const value = fn(...sources.map(path => findPath(path, root)));
			if (value !== undefined) {
				setRoot(data => assocPath(target, value, data));
			}
		}
	}, [prevData, root, setRoot, sources, target, fn]);
}
